import { uuid } from 'short-uuid';

export const generateUUID = () => uuid().replaceAll('-', '').toUpperCase();
